import './app/publicPath'

const Vue = window.Vue

Vue.component('Slider', () => import('./app/Slider/Slider.vue'))